import { createRouter, createWebHistory } from 'vue-router';
import AdminLayout from '@/layouts/AdminLayout.vue';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import HomePage from '@/views/HomePage.vue';
import Login from '@/components/Login.vue';
import Dashboard from '@/components/Dashboard.vue';
import UsuarioCadastro from '@/components/UsuarioCadastro.vue';
import HorariosAtendimento from '@/components/HorariosAtendimento.vue';
import RegisterProperty from '@/components/RegisterProperty.vue';
import PropertyList from '@/components/PropertyList.vue';
import PropertyForm from '@/components/PropertyForm.vue';
import BrokerList from '@/components/BrokerList.vue';
import BrokerForm from '@/components/BrokerForm.vue';
import UserForm from '@/components/UserForm.vue';
import UserList from '@/components/UserList.vue';
import EnterpriseForm from '@/components/EnterpriseForm.vue';
import EnterpriseList from '@/components/EnterpriseList.vue';
import VideoList from '@/components/VideoList.vue';
import VideoForm from '@/components/VideoForm.vue';
import PropertyDetails from '@/components/PropertyDetails.vue';
import ContractTemplateList from '@/components/ContractTemplateList.vue';
import ContractTemplateForm from '@/components/ContractTemplateForm.vue';
import TrainingVideos from '@/components/TrainingVideos.vue';
import ClientList from '@/components/ClientList.vue';
import ClientForm from '@/components/ClientForm.vue';

const routes = [
  {
    path: '/app/manager',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    component: DefaultLayout,
    children: [
      {
        path: '/',
        name: 'HomePage',
        component: HomePage
      },
      {
        path: '/horarios',
        name: 'HorariosAtendimento',
        component: HorariosAtendimento
      },
      {
        path: '/cadastre-seu-imovel',
        name: 'register-property',
        component: RegisterProperty
      },
      {
        path: '/imovel/:slug',
        name: 'detalhes',
        component: PropertyDetails,
        props: true
      }
    ]
  },
  {
    path: '/app',
    component: AdminLayout,
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
      },
      {
        path: 'imoveis',
        name: 'Imoveis',
        component: PropertyList,
      },
      {
        path: 'imoveis/novo',
        name: 'property-create',
        component: PropertyForm,
      },
      {
        path: 'imoveis/editar/:id',
        name: 'property-edit',
        component: PropertyForm,
        props: true,
      },
      {
        path: 'corretores',
        name: 'Corretores',
        component: BrokerList,
      },
      {
        path: 'corretores/novo',
        name: 'broker-create',
        component: BrokerForm,
      },
      {
        path: 'corretores/editar/:id',
        name: 'broker-edit',
        component: BrokerForm,
        props: true,
      },
      {
        path: 'usuarios',
        name: 'Usuários',
        component: UserList,
      },
      {
        path: 'usuarios/novo',
        name: 'user-create',
        component: UserForm,
      },
      {
        path: 'usuarios/editar/:id',
        name: 'user-edit',
        component: UserForm,
        props: true,
      },
      {
        path: 'empresa',
        name: 'Empresa',
        component: EnterpriseList,
      },
      {
        path: 'empresa/editar/:id',
        name: 'enterprise-edit',
        component: EnterpriseForm,
        props: true,
      },
      {
        path: 'videos',
        name: 'Videos',
        component: VideoList,
      },
      {
        path: 'videos/novo',
        name: 'video-create',
        component: VideoForm,
      },
      {
        path: 'videos/editar/:id',
        name: 'video-edit',
        component: VideoForm,
        props: true,
      },
      {
        path: "/training-videos",
        name: "TrainingVideos",
        component: TrainingVideos,
      },
      {
        path: 'modelos-documento',
        name: 'contract-template',
        component: ContractTemplateList,
      },
      {
        path: 'modelos-documento/novo',
        name: 'contract-template-create',
        component: ContractTemplateForm,
      },
      {
        path: 'modelos-documento/editar/:id',
        name: 'contract-template-edit',
        component: ContractTemplateForm,
        props: true,
      },
      {
        path: 'clientes',
        name: 'Clientes',
        component: ClientList,
      },
      {
        path: 'clientes/novo',
        name: 'client-create',
        component: ClientForm,
      },
      {
        path: 'clientes/editar/:id',
        name: 'client-edit',
        component: ClientForm,
        props: true,
      },
    ],
  },

  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
